import classNames from 'classnames';
import * as React from 'react';

/**
 * properties for a box
 */
export interface BoxProps extends React.HTMLAttributes<HTMLDivElement> {
    /**
     * @deprecated use the 'style.width' attribute instead
     */
    // a CSS width property string
    width?: string;
    /**
     * @deprecated use the 'style.height' attribute instead
     */
    // a CSS height property string
    height?: string;
    // if true, render a modal
    modal?: boolean;
    // if true, render an open modal
    open?: boolean;
    // the child nodes of the component
    children?: React.ReactNode;
    // only for modals - an optional ID
    modalId?: string;
}

const Box = React.forwardRef<HTMLDivElement, BoxProps>(
    (
        {
            modal = false,
            open = false,
            width = 'auto',
            height = 'auto',
            children,
            modalId,
            ...rest
        },
        ref,
    ) => {
        const needsStyleAttribute = width !== 'auto' || height !== 'auto';
        const styleAttribute = {
            width,
            height,
        };

        if (modal) {
            return (
                <div
                    className={classNames(
                        `a-box--modal ${open ? '-show' : ''}`,
                    )}
                    id={modalId}
                >
                    <div
                        className="a-box -floating"
                        style={needsStyleAttribute ? styleAttribute : undefined}
                        ref={ref}
                        {...rest}
                    >
                        {children}
                    </div>
                </div>
            );
        }
        return (
            <div
                className="a-box -floating"
                style={needsStyleAttribute ? styleAttribute : undefined}
                ref={ref}
                {...rest}
            >
                {children}
            </div>
        );
    },
);

Box.displayName = 'Box';

export { Box };
